import http from './http';

const BASE = 'suscripciones';

// Reads, plus the plan change of the tenant (roles 1/2 only, S2): preview, confirm (idempotent) and cancel the scheduled change.
// The ledger (estado-cuenta) replaces the deprecated pagos-realizados list.
export default {
  getPreviewCambioPlan(idPlan) {
    return http.get(`${BASE}/cambio-plan/preview`, { params: { id_plan: idPlan } }).then((response) => response.data.data);
  },
  // Only id_plan travels in the body; the tenant comes from the token. The key identifies ONE confirmation attempt.
  cambiarPlan(idPlan, clave) {
    return http
      .post(`${BASE}/cambiar-plan`, { id_plan: idPlan }, { headers: { 'Idempotency-Key': clave } })
      .then((response) => response.data.data);
  },
  cancelarCambioProgramado() {
    return http.delete(`${BASE}/cambio-plan-programado`).then((response) => response.data.data);
  },
  // Add-on modules (S3, roles 1/2 write; 8/9 only read the list). The price always comes from the catalog: only `modulo` travels.
  getModulos() {
    return http.get(`${BASE}/modulos`).then((response) => response.data.data);
  },
  getPreviewModulo(modulo, accion) {
    return http.get(`${BASE}/modulos/preview`, { params: { modulo, accion } }).then((response) => response.data.data);
  },
  activarModulo(modulo, clave) {
    return http
      .post(`${BASE}/modulos/activar`, { modulo }, { headers: { 'Idempotency-Key': clave } })
      .then((response) => response.data.data);
  },
  desactivarModulo(modulo, clave) {
    return http
      .post(`${BASE}/modulos/desactivar`, { modulo }, { headers: { 'Idempotency-Key': clave } })
      .then((response) => response.data.data);
  },
  // "Mantener módulo": cancels the scheduled baja. Idempotent by state on the backend, so no key.
  cancelarBajaModulo(modulo) {
    return http.delete(`${BASE}/modulos/baja-programada/${encodeURIComponent(modulo)}`).then((response) => response.data.data);
  },
  // Online payment of the plan (roles 1/2). NO amount travels: the backend computes it. The key identifies ONE payment attempt;
  // the answer carries the Mercado Pago `init_point` to redirect to.
  pagar(clave) {
    return http.post(`${BASE}/pagar`, {}, { headers: { 'Idempotency-Key': clave } }).then((response) => response.data.data);
  },
  getPlanActual() {
    return http.get(`${BASE}/plan-actual`).then((response) => response.data.data);
  },
  getPlanesDisponibles() {
    return http.get(`${BASE}/planes-disponibles`).then((response) => response.data.data);
  },
  getResumen() {
    return http.get(`${BASE}/resumen`).then((response) => response.data.data);
  },
  getEstadoCuenta({ page, limit } = {}) {
    const params = {};
    if (page !== undefined) params.page = page;
    if (limit !== undefined) params.limit = limit;
    return http.get(`${BASE}/estado-cuenta`, { params }).then((response) => response.data.data);
  },
  getPagosFuturos() {
    return http.get(`${BASE}/pagos-futuros`).then((response) => response.data.data);
  },
};
